import { useNavigate } from 'react-router-dom';

import { ErrorPanel } from '../components/common/ErrorPanel';
import { PageShell } from '../components/common/PageShell';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <PageShell>
      <ErrorPanel
        title="Page not found"
        message="The page you were looking for does not exist."
        onBack={() => navigate('/', { replace: true })}
      />
    </PageShell>
  );
}
